export default function ElectronicBusinessCards(){
    return (
        <div>
            电子名片
        </div>
    )
}